import React from "react";
import { RegisterDevState } from "../../states/RegisterDevState";
import { Button, Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import Media from "react-media";
import ReCAPTCHA from "react-google-recaptcha";
import { ConfigProvider } from "../../services/configuration/ConfigProvider";
import { VerifyRegisterDev } from "./VerifyRegisterDev";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { AuthService } from "../../services/authentication/AuthService";
import Select from "../../components/select/Select";
import "./RegisterDev.scss";


export class RegisterDev extends React.Component<any, RegisterDevState> {
  volumeList = ["0 - 100.000", "100.000€ - 500.000€", "500.000€ - 1.000.000€", "Oltre 1.000.000"];

  // @ts-ignore
  private recaptchaKeyV2 = ConfigProvider.getInstance().getConfiguration().recaptchaKeyV2;


  constructor(props: any) {
    super(props);

    this.state = {
      nameSurname: "",
      email: "",
      emailError: "Formato email non coretto.",
      phone: "",
      companyName: "",
      addressCompany: "",
      siteCompany: "",
      volume: "",
      optionsInfoAdd: "",
      confirm: false,
      captcha: false,
      emailIsValid: true,
      siteCompanyIsValid: true,
      volumeIsValid: true,
      captchaIsValid: true,
      confirmIsValid: true,
      rotateAnimation: false,
      isModalOpen: false,
    };

    this.emailHandler = this.emailHandler.bind(this);
  }

  componentDidMount(): void {
    const formDataString = sessionStorage.getItem('formData');

    GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Compila i campi e invia la richiesta', {});

    if (formDataString !== null) {
      const formDataObject = JSON.parse(formDataString);

      this.setState({
        nameSurname: formDataObject.nameSurname,
        email: formDataObject.email,
        phone: formDataObject.phone,
        companyName: formDataObject.companyName,
        addressCompany: formDataObject.addressCompany,
        siteCompany: formDataObject.siteCompany,
        volume: formDataObject.volume,
        optionsInfoAdd: formDataObject.optionsInfoAdd,
      }, () => {
        sessionStorage.removeItem('formData');
      })
    }
  }

  private renderDesktopHeader(): JSX.Element {
    return <HeaderDesktop showBack={true} showLogout={false} showTitle={true} title={"RICHIEDI UN ACCOUNT SVILUPPATORE"} />;
  }

  private renderMobileHeader(): JSX.Element {
    return <HeaderMobile showBack={true} showLogout={false} showTitle={true} title={"RICHIEDI UN ACCOUNT SVILUPPATORE"} />;
  }

  private handlerCaptcha = (token: string | null) => {
    this.setState({
      captcha: token !== null,
      captchaIsValid: token !== null
    });
  }

  private emailHandler = (event: any) =>
    this.setState({
      email: event.target.value,
      emailIsValid: this.isEmailPattern(event.target.value),
      emailError: "Formato email non coretto."
    });

  private formInputFull = () =>
    this.state.nameSurname &&
    this.state.email &&
    this.state.emailIsValid &&
    this.state.phone &&
    this.state.companyName &&
    this.state.addressCompany &&
    this.state.siteCompany &&
    this.state.siteCompanyIsValid &&
    this.state.volume &&
    this.state.confirm &&
    this.state.captcha;

  private renderKo = () => {
    this.showResultPage(this.props.history, VerifyRegisterDev.KO);
    sessionStorage.setItem('formData', JSON.stringify({
      nameSurname: this.state.nameSurname,
      email: this.state.email,
      phone: this.state.phone,
      companyName: this.state.companyName,
      addressCompany: this.state.addressCompany,
      siteCompany: this.state.siteCompany,
      volume: this.state.volume,
      optionsInfoAdd: this.state.optionsInfoAdd,
    }));
  }

  private formHandler = (event: any) => {
    event.preventDefault();

    AuthService
      .getInstance()
      .requestDeveloperAccount(
        this.state.optionsInfoAdd,
        this.state.addressCompany,
        this.state.companyName,
        this.state.volume,
        this.state.siteCompany,
        this.state.nameSurname,
        this.state.email,
        this.state.phone,
      )
      .subscribe(
        (result) => {
          if (result === VerifyRegisterDev.OK) {
            // vai alla resultPage per il caso OK
            this.showResultPage(this.props.history, VerifyRegisterDev.OK);
          } else if (result === VerifyRegisterDev.USED) {
            this.setState({
              emailError: "Esiste già un’utenza sviluppatore per questa email.",
              emailIsValid: false
            });
            GoogleTagManagerService
              .getInstance()
              .pushCustomError(
                "custom_error",
                "general",
                "",
                "Esiste già un’utenza sviluppatore per questa email.",
                undefined,
                false
              );
          } else {
            // vai alla resultPage per il caso KO
            GoogleTagManagerService
              .getInstance()
              .pushCustomError(
                "custom_error",
                "general",
                "500",
                "Si è verificato un error.",
                undefined,
                false
              );
            this.showResultPage(this.props.history, VerifyRegisterDev.KO);
            this.renderKo();
          }
        },
        () => {
          this.renderKo();
        }
      );
  }



  private generateTimeStamp() {
    const timestamp = new Date().getTime().toString();
    return timestamp;
  }

  private showResultPage(history: any, result?: VerifyRegisterDev) {
    if (result === VerifyRegisterDev.OK || result === VerifyRegisterDev.KO) {

      let timeStamp = localStorage.getItem('timeStamp');

      if (!timeStamp) {
        timeStamp = this.generateTimeStamp();
        localStorage.setItem('timeStamp', timeStamp);
      }

      GoogleTagManagerService.getInstance().pushRequestOutcome(
        timeStamp,
        result === VerifyRegisterDev.OK ? 1 : 0,
        result === VerifyRegisterDev.OK ? 200 : 400,
        null,
      )

      if (result !== VerifyRegisterDev.OK) {
        GoogleTagManagerService.getInstance().pushPageEvent('/registerDevResult/failure', "Richiedi utenza sviluppatore", {});

        GoogleTagManagerService.getInstance().pushCustomError(
          "custom_error",
          "general",
          "",
          "si è verificato un errore durante la creazione della password",
          undefined,
          false
        );
      }
    }
    history.push("/registerDevResult", { result: result });
  }

  handleValueSelect = (selectedValue: string) => {
    if (selectedValue) {
      this.setState({
        volume: selectedValue,
        volumeIsValid: true,
        isModalOpen: false,
        rotateAnimation: false,
      });
    } else {
      this.setState({
        volume: "",
        volumeIsValid: false,
      });
    }
  };

  handleIconClick = () => {
    this.setState((prevState) => ({
      rotateAnimation: !prevState.rotateAnimation,
      isModalOpen: !prevState.isModalOpen,
    }));
  };


  private isEmailPattern = (s: string): boolean => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(s);
  private isWebsitePattern = (s: string): boolean => /^(https:\/\/)?[a-zA-Z0-9-]{1,255}\.[a-zA-Z0-9-]{2,63}\.[a-zA-Z0-9]{2,16}/.test(s);

  render() {
    return (
      <>
        <div id={"main-container-register-dev"}>
          <Media query="(max-width: 1064px)" render={() => this.renderMobileHeader()} />
          <Media query="(min-width: 1065px)" render={() => this.renderDesktopHeader()} />
          <h1 className="textTitle">Compila i campi e invia la richiesta</h1>
          <div className="wrapper-form">
            <form className="box-form-dev" onSubmit={this.formHandler}>
              <div className="box-container-form">

                <TextField
                  id="nameSurname"
                  label="Nome e Cognome"
                  value={this.state.nameSurname}
                  onChange={(event) => this.setState({ nameSurname: event.target.value })}
                />

                <TextField
                  id="email"
                  label="Email"
                  value={this.state.email}
                  error={!this.state.emailIsValid}
                  helperText={!this.state.emailIsValid ? this.state.emailError : ""}
                  onChange={(event) => this.setState({ email: event.target.value, emailIsValid: true, emailError: "Formato email non coretto." })}
                  onBlur={(event) => {
                    this.setState({ emailIsValid: this.isEmailPattern(event.target.value) })
                    GoogleTagManagerService.getInstance().pushCustomError(
                      "custom_error",
                      "input",
                      "",
                      "Formato email non coretto.",
                      undefined,
                      false
                    )
                  }
                  }
                />

                <TextField
                  id="phone"
                  label="Numero Cellulare"
                  value={this.state.phone}
                  // onChange={(event) => this.setState({ phone: event.target.value.match(/^\+?\d*$/)?.toString() ?? this.state.phone })}
                  onChange={(event) => this.setState({ phone: event.target.value.match(/^(?:\+\d{0,2}\s?\d{0,10}|\d{0,10})$/)?.toString() ?? this.state.phone })}
                />

                <TextField
                  id="companyName"
                  label="Nome Azienda"
                  value={this.state.companyName}
                  onChange={(event) => this.setState({ companyName: event.target.value })}
                />

                <TextField
                  id="addressCompany"
                  label="Sede Azienda"
                  value={this.state.addressCompany}
                  onChange={(event) => this.setState({ addressCompany: event.target.value })}
                />

                <TextField
                  id="siteCompany"
                  label="Sito Azienda"
                  value={this.state.siteCompany}
                  error={!this.state.siteCompanyIsValid}
                  helperText={!this.state.siteCompanyIsValid ? "Formato link non coretto." : ""}
                  onChange={(event) => this.setState({ siteCompany: event.target.value, siteCompanyIsValid: true })}
                  onBlur={(event) => this.setState(
                    { siteCompanyIsValid: this.isWebsitePattern(event.target.value) }, (() => {
                      GoogleTagManagerService.getInstance().pushCustomError(
                        "custom_error",
                        "input",
                        "",
                        "Formato link non coretto.",
                        undefined,
                        false
                      )
                    }))}
                />

                <div className="box-select">
                  <Select
                    label="Volume annuo transato"
                    value={this.state.volume}
                    volumeList={this.volumeList}
                    volumeIsValid={!this.state.volumeIsValid}
                    setNewValue={(value: string) => {
                      this.setState({
                        volume: value
                      });
                    }}
                  />
                </div>

                <TextField
                  className="box-dev-input"
                  id="optionsInfoAdd"
                  label="Informazioni aggiuntive (opzionale)"
                  multiline
                  rows={4}
                  value={this.state.optionsInfoAdd}
                  onChange={(event) => this.setState({ optionsInfoAdd: event.target.value.match(/^.{0,500}$/)?.toString() ?? this.state.optionsInfoAdd })}
                />

                <ReCAPTCHA
                  sitekey={this.recaptchaKeyV2}
                  onChange={this.handlerCaptcha}
                />

                <div className="wrapper-check">
                  <div className="container-check-text">
                    <FormControlLabel
                      control={
                        <Checkbox
                          value={this.state.confirm}
                          onChange={(e) => {
                            this.setState((prevState) => ({ confirmIsValid: !prevState.confirm, confirm: !prevState.confirm }));
                          }}
                        />
                      }
                      label=""
                    />
                    <div className="box-text-condicional">
                      <p className="text-condicional">
                        Dichiaro di aver preso visione <br /> dell'
                        <a
                          href={`${/(mpos|posweb)/i.test(window.location.origin) ? 'https://www.nexi.it' : window.location.origin}/content/dam/m-pos/T & C Portale Sviluppatori Nexi POS App.pdf`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="link-dev"
                        >
                          informativa privacy
                        </a>.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-elements">
                <Button disabled={!this.formInputFull()} className={"change-password-submit-button"} type={"submit"}>
                  CONFERMA
                </Button>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}
